import axios from "axios";

const BASE_URL = "https://wethrift-backend.onrender.com/api/";

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

export const userRequest = () => {
  let TOKEN = "";

  try {
    const persistRoot = localStorage.getItem("persist:root");
    
    if (persistRoot) {
      const rootData = JSON.parse(persistRoot);
      
      // Sabse pehle 'user' slice check karte hain
      if (rootData.user) {
        const userData = typeof rootData.user === 'string' ? JSON.parse(rootData.user) : rootData.user;
        
        // Deep search for token in userData
        TOKEN = userData?.currentUser?.accessToken || 
                userData?.currentUser?.token || 
                userData?.accessToken || 
                userData?.token || "";
      }
    }

    // Agar abhi bhi nahi mila, toh pure localStorage mein "accessToken" search karo
    if (!TOKEN) {
      Object.keys(localStorage).forEach(key => {
        if (localStorage.getItem(key).includes("eyJhbGci")) { // JWT start check
            const match = localStorage.getItem(key).match(/"(?:accessToken|token)":"([^"]+)"/);
            if (match) TOKEN = match[1];
        }
      });
    }

  } catch (err) {
    console.error("Token Scanner Error:", err);
  }

  console.log("SCANNER RESULT:", TOKEN ? "✅ TOKEN ACQUIRED" : "❌ TOKEN NOT FOUND");

  return axios.create({
    baseURL: BASE_URL,
    headers: { token: `Bearer ${TOKEN}` },
  });
};